// @vendors
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
const PropTypes = require('prop-types');

// @components
import FooterAdvice from './../components/FooterAdvice/FooterAdvice'

// @utilities
const { FormattedText } = require('core/i18n').i18n;

class AggregatorGenericAdvice extends Component {

    handleButtonClick = () => {
        this.props.history.push('/myprofile/global/entities/manage')
    }

    render() {
        return (
            <FooterAdvice
                title={<FormattedText value={'aggregatorPSD2GenericAdvice-title'}/>}
                description={<FormattedText value={'aggregatorPSD2GenericAdvice-description'}/>}
                textButton={<FormattedText value={'aggregatorPSD2GenericAdvice-textButton'} />}
                onClickButton={() => this.handleButtonClick()}
            />
        )
    }
}

AggregatorGenericAdvice.propTypes = {
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorGenericAdvice);
